import { useUpdateEntity } from 'client/components/core/Sidebar/components/Settings/hooks/useUpdateProps'
import { useAppDispatch } from 'client/hooks/use-dispatch'
import { getSettingsEditing } from 'client/reducers/managementReducer'
import { useManagement } from 'client/store'
import { setSettingsEditing } from 'client/store/management/managementActions'
import React, { ReactNode } from 'react'
import { BaseSubEntity } from 'src/editor/layout/base-sub-entity'
import { FormSubEntityTypeEnum } from 'src/shared/entities/form/enums'
import {
  FormInterface,
  FormSubEntitiesInterface,
} from 'src/shared/entities/form/form.schema'
import { ContactSlugEnum } from 'src/shared/enums/contact-fields-enum'

export type FormBaseSubEntityProps = {
  formEntity: FormInterface
  subEntity: FormSubEntitiesInterface
  title: string
  children?: ReactNode
}

export const FormBaseSubEntity = ({
  formEntity,
  subEntity,
  title,
  children,
}: FormBaseSubEntityProps) => {
  const dispatch = useAppDispatch()

  const isEditing =
    useManagement(getSettingsEditing).subEntityId === subEntity.id

  const isRemoveRestricted =
    subEntity.type === FormSubEntityTypeEnum.SubmitButton ||
    (subEntity.type === FormSubEntityTypeEnum.Field &&
      subEntity.slug === ContactSlugEnum.Email)

  const updateEntity = useUpdateEntity<FormInterface>()

  const onEdit = () => {
    dispatch(
      setSettingsEditing({
        id: formEntity.id,
        type: formEntity.type,
        subEntityId: subEntity.id,
      }),
    )
  }
  const onRemove = () => {
    updateEntity({
      ...formEntity,
      subEntities: formEntity.subEntities.filter(s => s.id !== subEntity.id),
    })
  }
  return (
    <BaseSubEntity
      subEntity={subEntity}
      isEditing={isEditing}
      flex
      flexColumn
      title={title}
      isRemoveAllowed={!isRemoveRestricted}
      onEdit={onEdit}
      onRemove={onRemove}
    >
      {children}
    </BaseSubEntity>
  )
}
